<template>
  <div :class="componentClasses">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const componentClasses = computed(() => [
  'stk-box',
]);
</script>

<style>
.stk-box {
  background-color: var(--stk-scheme-main);
  border-radius: 0.75rem;
  border-style: solid;
  border-color: var(--stk-border);
  border-width: 1px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 1px 0px rgba(0, 0, 0, 0.02);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  break-inside: avoid;
}
</style>
